import './ChildProfilePreview.scss'

import cls from 'classnames'
import { LineClamp } from '../../../../widgets/LineClamp'
import { OnboardingAvatar } from '../OnboardingAvatar/OnboardingAvatar'

type ChildProfilePreviewProps = {
	readonly age?: string
	readonly className?: string
	readonly direction?: 'vertical' | 'horizontal'
	readonly idx: number
	readonly name?: string
}

export const ChildProfilePreview = ({
	idx,
	name = '',
	age,
	className,
	direction = 'horizontal',
}: ChildProfilePreviewProps) => (
	<div
		className={cls(
			'child-profile-preview',
			direction == 'vertical' && 'child-profile-preview--col',
			className,
		)}
	>
		<OnboardingAvatar idx={idx} />

		<div
			className={cls(
				'child-profile-preview__info',
				direction == 'vertical' && 'child-profile-preview__info--col',
			)}
		>
			<LineClamp
				className="font-bold break-words text-sm sm:text-base leading-tight sm:leading-snug"
				maxLines={2}
			>
				{name}
			</LineClamp>

			<p className="text-xs sm:text-sm">{age}</p>
		</div>
	</div>
)
